<template>
    <main class="content-wrap">
        <div class="content-container">
            <div class="intro row glasovanja-rezultati" id="glasovanje-rezultati">
                <div class="distinct-images-container" v-for="vote_item in getDistinctImages" :key="vote_item.id">
                    <div class="images" v-if="vote_item[0]['type'] === 'image'">
                        <div class="image-container" v-for="image in vote_item" :key="image.id">
                            <img :src="image.path" :alt="image.id">
                            <div v-for="(results, index) in numberOfImageVotes(image.id)" :key="index" class="koncni-rezultati">
                                <div v-for="(result, key) in results" :key="key">
                                    <hr v-if="key === 'seštevek'">
                                    <strong v-if="key === 'seštevek'">{{ `${key}: ${result}` }}</strong>
                                    <span v-else>{{ `${key}: ${result}` }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="titles-container" >
                    <div v-for="(result, index) in getDistinctTitles" :key="result.id" v-cloak>
                        <div v-if="index === 0">
                            <strong v-cloak>1. mesto: {{ `${result.title}  (${result.count} glas-ov)` }}</strong>
                        </div>
                        <div v-else-if="result.id.indexOf('custom') > -1" v-cloak>
                            <strong v-cloak>{{ index + 1 }}. mesto:</strong> {{ result.title }}: (dodatni naslov)
                        </div>
                        <div v-else v-cloak>
                            <strong v-cloak>{{ index + 1 }}. mesto:</strong> {{ result.title }}: ({{ result.count }} glasov)
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>

export default {
    props: ['status', 'message', 'rezultati'],
    data() {
        return {
            nextPosition: 1,
            vrstniRed: [1,2,3,4,5,6,7,8,9,10],
            positionClass: {
                1: "prvo mesto",
                2: "drugo mesto",
                3: "tretje mesto",
                4: "četrto mesto",
                5: "peto mesto",
                6: "šesto mesto",
                7: "sedmo mesto",
                8: "osmo mesto",
                9: "deveto mesto",
                10: "deseto mesto",
                "prvo mesto": 10,
                "drugo mesto": 9,
                "tretje mesto": 8,
                "četrto mesto": 7,
                "peto mesto": 6,
                "šesto mesto": 5,
                "sedmo mesto": 4,
                "osmo mesto": 3,
                "deveto mesto": 2,
                "deseto mesto": 1

            }
		}
	},
	mounted() {
        $("#glasovanje-body #footer > .ui.container").append("<img src='/images/glasovanja/modrijan-logo.png' class='Modrijan logo'/>");
	},
    methods: {
        numberOfImageVotes(imageId) {
            if (this.rezultati == null || !this.rezultati) {
                return "no data";
            }
            const parsedResults = this.rezultati               // REZULTATI  
                .map(item => JSON.parse(item.results))            // parse JSON results field (json type)
                .reduce((acc, obj) => acc.concat(obj), [])        // flatten array
            const imagesArr = parsedResults                    // SLIKE
                .reduce((acc, obj) => acc.concat(obj.images), []) // reduce to images array { id: x, path: xy, position: xz}
                .filter(image => image.id == imageId);             // get only the data for imageId            
            const positions = parsedResults[0].images          // POZICIJE
                .reduce((acc, obj) => acc.concat(obj), [])        // flatten array
                .map(item => item.position);                      // get all positions for images                
            const positionSum = positions.sort((a, b) => a - b).map(position => {    // IZRAČUN POZICIJ ZA SLIKO
                return Object.assign({},
                    { [this.positionClass[position]]: imagesArr.filter(image => image.position === position).length } // calculates all placements (1,2,3,...4,5,6,7,8,9,10)
            );});
            const sumSum = positionSum                          // IZRAČUN SUME POZICIJ ZA SLIKO
                .concat(positionSum.reduce((acc, item) => 
                    Object.assign(acc, { "seštevek": (item[Object.keys(item)] * this.positionClass[Object.keys(item)[0]]) + acc["seštevek"] }), { "seštevek" : 0})); // adds sum to the position values      
            return sumSum;
        }
    },
    computed: {
        getDistinctImages() {
            if (this.rezultati) {
                const results = JSON.parse(this.rezultati[0].results);
                const distinctContent = results[0];
                return distinctContent;
            }
            return [{ id: "no image", path: "", type: "image", position: 1}];
        },
        getDistinctTitles() {
            if (this.rezultati) {
                const parsedResults = this.rezultati
                    .map(item => JSON.parse(item.results))            // parse JSON results field (MySql json type)
                    .reduce((acc, obj) => acc.concat(obj),[])         // flatten array
                const titleArr = parsedResults
                    .reduce((acc, obj) => acc.concat(obj.titles), []); // reduce to title array { id: x, type: xy, title: xz}
                const distinctTitles = titleArr.filter((item, index) => 
                        !titleArr.filter((title, idx) => index > idx && title.title === item.title).length); // distinct values = comparing the indexes and the array, looking only backwards
                const titleCount = distinctTitles.map((title, index) => ({
                        id: title.id || `title${index+1}-custom`,
                        type: title.type,
                        title: title.title,
                        count: titleArr.filter(item => item.id === title.id).length
                    }))
                    .sort((a, b) => b.count - a.count);
                return titleCount;
            }
            return [{ id: "1",  type: "title", title: "ni naslovov"}];
        }
    }
}


</script>




// WEBPACK FOOTER //
// resources/assets/js/components/Glasovanja-rezultati.vue